const state = {
  isTourActive: false,
  shouldStartTour: false
}

const mutations = {
  SET_TOUR_ACTIVE(state, isActive) {
    state.isTourActive = isActive
  },
  SET_SHOULD_START_TOUR(state, shouldStart) {
    state.shouldStartTour = shouldStart
  }
}

const actions = {
  startTour({ commit }) {
    commit('SET_SHOULD_START_TOUR', true)
  },
  setTourActive({ commit }, isActive) {
    commit('SET_TOUR_ACTIVE', isActive)
  },
  resetTourFlags({ commit }) {
    commit('SET_SHOULD_START_TOUR', false)
    commit('SET_TOUR_ACTIVE', false)
  }
}

const getters = {
  isTourActive: state => state.isTourActive,
  shouldStartTour: state => state.shouldStartTour
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} 